import React, { useState, useEffect, useContext } from 'react';
import styled from 'styled-components';
import { FloatingBubble, Toast } from 'antd-mobile';
import { AddOutline } from 'antd-mobile-icons';
import { createWorkOrderDefect, getWorkOrderDefects } from '../api';
import { matchesPermission } from '../utils/permission-helpers';
import DefectsList from '../components/DefectsList';
import UserSelfContext from '../utils/self-context';
import AddDefectPopup from '../components/AddDefectPopup';

const DefectsWrapper = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-flow: column;
`;

const ToastContent = styled.div`
	word-break: normal;
	text-align: center;
	width: 100%;
`;

const ListWrapper = styled.div`
	flex: 1;
	min-height: 0;
	overflow:  auto;
	width: 100%;
	background: #f0f2f5;
`;

function Defects(props) {
	const {
		workOrderId,
		stats,
		isClosed,
		onChange
	} = props;
	const [loading, setLoading] = useState(true);
	const [err, setErr] = useState(false);
	const [defects, setDefects] = useState([]);
	const [showPopover, setShowPopover] = useState(false);
	const [saving, setSaving] = useState(false);
	const { userSelf } = useContext(UserSelfContext);

	async function fetchDefects() {
		setLoading(true);
		const query = `?work_order_id=${workOrderId}`;

		try {
			const data = await getWorkOrderDefects(workOrderId, query);
			setDefects(data.items);
		} catch (e) {
			setErr(true);
		}

		setLoading(false);
	}

	useEffect(() => {
		if (workOrderId) {
			fetchDefects();
		}
	}, [workOrderId]);

	async function handleSave(data) {
		setSaving(true);
		try {
			await createWorkOrderDefect(workOrderId, data);
			fetchDefects();
			setShowPopover(false);
			onChange();
		} catch (e) {
			Toast.show({
				icon: 'fail',
				content: <ToastContent>
					Unable to save Additional Work. Something went wrong.
				</ToastContent>
			});
		}
		setSaving(false);
	}

	return (
		<DefectsWrapper>
			{matchesPermission(userSelf, 'add_defects') && !isClosed && <FloatingBubble
				style={{
					'--initial-position-bottom': '74px',
					'--initial-position-right': 'calc(50% - 24px)',
					'--edge-distance': '24px'
				}}
				onClick={() => setShowPopover(true)}
			>
				<AddOutline fontSize={32} />
			</FloatingBubble>}
			<ListWrapper>
				<DefectsList
					stats={stats}
					loading={loading}
					defects={defects}
					workOrderId={workOrderId}
				/>
			</ListWrapper>
			<AddDefectPopup
				onSave={handleSave}
				saving={saving}
				visible={showPopover}
				onClose={() => setShowPopover(false)}
			/>
		</DefectsWrapper>
	);
}

export default Defects;
